<template>
  <div>
    <nav class="mobile-tab-bar" aria-label="Main">
      <component
        :is="tab.href ? 'a' : 'router-link'"
        v-for="tab in tabs"
        :key="tab.key"
        :to="tab.href ? undefined : tab.to"
        :href="tab.href || undefined"
        class="mobile-tab-bar__item"
        :class="{ 'is-active': isActiveItem(tab) }"
        :aria-current="isActiveItem(tab) ? 'page' : null">
        <img
          :src="iconFor(tab)"
          :class="['mobile-tab-bar__icon', 'mz-nav-icon', { 'is-active': iconIsActive(tab) }]"
          alt="" />
        <span class="mobile-tab-bar__label">{{ tab.label }}</span>
      </component>

      <button
        type="button"
        class="mobile-tab-bar__item"
        :class="{ 'is-active': moreActive }"
        :aria-current="moreActive ? 'page' : null"
        aria-haspopup="dialog"
        @click="sheetOpen = true">
        <i class="ri-more-line mobile-tab-bar__icon mobile-tab-bar__icon--font" aria-hidden="true"></i>
        <span class="mobile-tab-bar__label">More</span>
      </button>
    </nav>

    <bottom-sheet v-model="sheetOpen" title="More">
      <nav class="mobile-more-sheet" aria-label="More">
        <component
          :is="item.href ? 'a' : 'router-link'"
          v-for="item in more"
          :key="item.key"
          :to="item.href ? undefined : item.to"
          :href="item.href || undefined"
          class="mobile-more-sheet__item"
          @click.native="sheetOpen = false">
          <img :src="iconFor(item)" class="mobile-more-sheet__icon mz-nav-icon" alt="" />
          <span>{{ item.label }}</span>
        </component>

        <button type="button" class="mobile-more-sheet__item" @click="onSelectApp">
          <img :src="icons.IconApp" class="mobile-more-sheet__icon mz-nav-icon" alt="" />
          <span>Select Application</span>
        </button>
        <button
          v-if="!hideCompanySelection"
          type="button"
          class="mobile-more-sheet__item"
          @click="onSelectCompany">
          <img :src="icons.IconCompany" class="mobile-more-sheet__icon mz-nav-icon" alt="" />
          <span>Select Company</span>
        </button>

        <router-link
          :to="{ name: 'MasterConfiguration' }"
          class="mobile-more-sheet__item"
          @click.native="sheetOpen = false">
          <i class="ri-settings-3-line mobile-more-sheet__icon" aria-hidden="true"></i>
          <span>Configuration</span>
        </router-link>

        <a href="#" class="mobile-more-sheet__item" @click.prevent>
          <i class="ri-user-line mobile-more-sheet__icon" aria-hidden="true"></i>
          <span>Profile</span>
        </a>

        <div class="mobile-more-sheet__section">
          <p class="mobile-more-sheet__section-title">Theme</p>
          <theme-picker variant="list" />
        </div>

        <button type="button" class="mobile-more-sheet__item mobile-more-sheet__item--danger" @click="onSignOut">
          <i class="ri-logout-box-r-line mobile-more-sheet__icon" aria-hidden="true"></i>
          <span>Sign Out</span>
        </button>
      </nav>
    </bottom-sheet>
  </div>
</template>

<script>
import BottomSheet from '@/components/BottomSheet.vue';
import ThemePicker from '@/components/ThemePicker.vue';
import { mobileTabs } from '@/util/mobileTabs';
import { navIconFor, isNavIconActive, isNavItemActive } from '@/layouts/navConfig';

export default {
  name: 'MobileTabBar',
  components: { BottomSheet, ThemePicker },
  props: {
    navItems: { type: Array, required: true },
    icons: { type: Object, required: true },
    hideCompanySelection: { type: Boolean, default: false },
  },
  data() {
    return { sheetOpen: false };
  },
  computed: {
    split() {
      return mobileTabs(this.navItems);
    },
    tabs() {
      return this.split.tabs;
    },
    more() {
      return this.split.more;
    },
    moreActive() {
      return this.more.some((item) => this.isActiveItem(item));
    },
  },
  watch: {
    // sheet gak boleh nyangkut kebuka pas ganti route (misal tombol back)
    $route() {
      this.sheetOpen = false;
    },
  },
  methods: {
    isActiveItem(item) {
      return isNavItemActive(item, this.$route.name);
    },
    iconFor(item) {
      return navIconFor(item, this.icons, this.$route.name);
    },
    iconIsActive(item) {
      return isNavIconActive(item, this.$route.name);
    },
    onSelectApp() {
      this.sheetOpen = false;
      this.$emit('select-app');
    },
    onSelectCompany() {
      this.sheetOpen = false;
      this.$emit('select-company');
    },
    onSignOut() {
      this.sheetOpen = false;
      this.$emit('sign-out');
    },
  },
};
</script>

<style scoped>
.mobile-tab-bar {
  display: none;
}

@media (max-width: 768px) {
  .mobile-tab-bar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1030;
    display: flex;
    align-items: stretch;
    height: calc(56px + env(safe-area-inset-bottom));
    padding-bottom: env(safe-area-inset-bottom);
    background-color: var(--mz-surface);
    border-top: 1px solid var(--mz-border);
    box-shadow: var(--mz-shadow-1);
  }
}

.mobile-tab-bar__item {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-width: 0;
  border: 0;
  background: transparent;
  color: var(--mz-text-muted);
  text-decoration: none;
}

.mobile-tab-bar__item.is-active {
  color: var(--mz-primary-ink);
}

.mobile-tab-bar__icon {
  width: 22px;
  height: 22px;
}

.mobile-tab-bar__icon--font {
  width: auto;
  height: auto;
  font-size: 22px;
  line-height: 1;
}

.mobile-tab-bar__label {
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: var(--mz-fs-xs);
  font-weight: var(--mz-fw-label);
}

.mobile-more-sheet {
  display: flex;
  flex-direction: column;
}

.mobile-more-sheet__item {
  display: flex;
  align-items: center;
  gap: var(--mz-space-3);
  min-height: 48px;
  width: 100%;
  padding: 0 var(--mz-space-4);
  border: 0;
  background: transparent;
  color: var(--mz-text);
  font-size: var(--mz-fs-base);
  text-align: left;
  text-decoration: none;
}

.mobile-more-sheet__item:active {
  background-color: var(--mz-surface-2);
}

.mobile-more-sheet__item--danger {
  color: var(--mz-danger-ink);
}

.mobile-more-sheet__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 24px;
  height: 24px;
  font-size: 20px;
}

.mobile-more-sheet__section {
  padding: var(--mz-space-2) var(--mz-space-4) 0;
}

.mobile-more-sheet__section-title {
  margin: 0 0 var(--mz-space-1);
  color: var(--mz-text-muted);
  font-size: var(--mz-fs-xs);
  font-weight: var(--mz-fw-label);
  letter-spacing: var(--mz-ls-label);
  text-transform: uppercase;
}
</style>
